<template>
  <Select
    :items="opcoes"
    :selectedItem="filter.nfseAntecipada"
    :label="filtro.name"
    searchPlaceholder="Buscar opção"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';

export default {
  components: {
    Select
  },
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      filter: {
        nfseAntecipada: {
          id: '',
          name: ''
        }
      },
      opcoes: [
        { id: 'true', name: 'Sim' },
        { id: 'false', name: 'Não' }
      ]
    };
  },
  methods: {
    atualizar(opcao) {
      this.filter.nfseAntecipada = opcao;

      // Quando o user clica em "Selecione" dentro do dropdown, o Select.vue emite
      // `{ id: '', name: '' }`. Em vez de poluir a URL com `?nfse_antecipada=`
      // (valor vazio), removemos o param — alinhado ao edge case documentado na
      // spec ("NFS-e antecipada 'todos' nao polui URL").
      if (opcao.id === '') {
        this.$removeFiltroDaURL(this.filtro.filtro, this.path);
        this.$store.commit('removeFiltroAplicado', this.filtro.filtro);
        return;
      }

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.nfseAntecipada.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.nfseAntecipada.id
      });
    }
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.opcoes, this.filter.nfseAntecipada);
  }
}
</script>
